import React from 'react';

import { PickersDayProps } from '@mui/x-date-pickers';
import type {} from '@mui/x-date-pickers/AdapterLuxon';
import { DateTime } from 'luxon';

import type { TRange } from '@common/helpers/useRangeDateQuery';

import DateRangePickerDay from './index';

export type DateRangePickerDayContainerProps = PickersDayProps<any> & {
	tempDateRange: TRange;
	hoveredDate: DateTime | null;
	setHoveredDate: (day: DateTime | null) => void;
	isSelectingEndDate: boolean;
};

function DateRangePickerDayContainer({
	tempDateRange,
	hoveredDate,
	setHoveredDate,
	isSelectingEndDate,
	...props
}: DateRangePickerDayContainerProps) {
	const { day } = props;

	const [startDate, endDate] = tempDateRange;

	const handleMouseEnter = () => setHoveredDate(day);
	const handleMouseLeave = () => setHoveredDate(null);

	const startDateMatch = startDate && day.hasSame(startDate, 'day');
	const endDateMatch = endDate && day.hasSame(endDate, 'day');
	const inRange = startDate && endDate && day > startDate && day < endDate;

	let isHovered = false;
	if (hoveredDate) {
		if (isSelectingEndDate) {
			if (day > startDate && day <= hoveredDate) {
				isHovered = true;
			}
		} else if (day >= hoveredDate && day < endDate) {
			isHovered = true;
		}
	}

	return (
		<DateRangePickerDay
			{...props}
			isStartDate={startDateMatch}
			isEndDate={endDateMatch}
			isInRange={inRange}
			isHovered={isHovered && !inRange}
			onMouseEnter={handleMouseEnter}
			onMouseLeave={handleMouseLeave}
			isSameDate={startDate.hasSame(endDate, 'day')}
		/>
	);
}

export default DateRangePickerDayContainer;
